import React, { Component, PropTypes } from 'react';

import './MoreMenu.css';

export default class MoreMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
        };

        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
    }

    handleMenuClick() {
        this.setState({
            visible: true,
        });
    }

    hideMenu() {
        this.setState({
            visible: false,
        });
    }

    render() {
        const display = this.state.visible ? `block` : `none`;

        return (
            <div>
                <i className="material-icons md-dark more-menu-button" onClick={this.handleMenuClick}>&#xE5D4;</i>
                <div className="more-menu" style={{display: display}}>
                    <div className="menu-close-target" onClick={this.hideMenu}></div>
                    <uL onClick={this.hideMenu}>
                        {this.props.children}
                    </uL>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/MoreMenu.jsx